
const getDateOrTime = (dateTimeStr, type) => {
    const [date, time] = dateTimeStr.split(", "); 
    return type === "date" ? date : type === "time" ? time : null;
  };

export default getDateOrTime;
  